import createReactComponent from '../createReactComponent';
export default createReactComponent('ux-circle', 'IconUxCircle', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M7 10v2a2 2 0 1 0 4 0v-2', key: 'svg-1' }],
  ['path', { d: 'M14 10l3 4', key: 'svg-2' }],
  ['path', { d: 'M14 14l3 -4', key: 'svg-3' }],
]);
